/** joins parameters into one string, separated with spaces */
export function Joiner(...styles) {
  return styles.join(" ");
}